<div class="content md3-surface  layout-1-auto ">
  <ng-container *ngIf="isLoading">
    <div class="content" style="position: absolute; width: 100%">
      <div class="splash loading"><div class="spinner"><div></div><div></div><div></div><div></div></div></div>
    </div>
  </ng-container>
  <ng-container *ngIf="!isLoading">
    <div class="md3-card-on-surface content">
      <div *ngIf="isLoadingPreview" class="content" style="position: absolute; width: 100%">
        <div class="splash loading"><div class="spinner"><div></div><div></div><div></div><div></div></div></div>
      </div>
      <div  class="host-container" style="height: 100%">
        <div [style.visibility]="isLoadingPreview ? 'hidden' : 'visible'" *ngIf="currentResource" style="height: 100%;">
          <div class="pdf-viewer-box" style="height: 1px;">
            <pdf-viewer class="host-pdf-view" style="display: block;"
                        (after-load-complete)="stopLoadingPDF($event)"
                        [src]="currentResource || null"
                        [render-text]="false" [original-size]="true" [fit-to-page]="true"
                        [show-borders]="true"
                        [show-all]="true"></pdf-viewer>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div [ngClass]="{'grid-1-auto': data.rcptID, 'spawn-reverse': !data.rcptID }">
        <ng-container *ngIf="data.rcptID">
          <ng-container *ngIf="securityHandler.canEdit()
                               && data.rcpt_enmIdent_ReceiptStatus < 10
                               && data.rcpt_enmIdent_ReceiptStatus !== 3
                               && conditions.visibleConditions().length > 0
                               && !data.rcptStatement">
            <i [ngClass]="{'c-red': conditions.visibleConditions().length > 0 && !conditions.acceptedAll(),
                          'c-green': conditions.visibleConditions().length > 0 && conditions.acceptedAll()
                        }"
               class="search-action far fa-check-circle" (click)="togglePopupMenu($event, conditionsPopUp)"></i>
          </ng-container>

          <exg-popup #conditionsPopUp [closeAlways]="false" style="width: 500px">
            <div class="md-menu content">

              <ng-container *ngIf="securityHandler.canEdit()
											&& data.rcpt_enmIdent_ReceiptStatus < 10
											&& data.rcpt_enmIdent_ReceiptStatus !== 3">
                <div class="app-list-acceptbox-accepted bg-green grid-1-auto" *ngIf="conditions.visibleConditions().length > 0 && conditions.acceptedAll()">
                  <p>Hinweise & Warnungen gelesen und akzeptiert!</p>
                  <div>
                    <button (click)="conditions.reset()"
                            class="md-btn">
                      {{getGlobal('reset')}}
                    </button>
                  </div>
                </div>
                <div class="app-list-acceptbox" *ngIf="conditions.visibleConditions().length > 0 && !conditions.acceptedAll()">
                  <div class="list-header typo-small">
                    {{conditions.header}}
                  </div>
                  <ng-container *ngFor="let condition of conditions.data; index as i">
                    <div class="list-row list-row-auto-1-auto typo-small"
                         *ngIf="condition.showCondition">
                      <div class="list-icon" style="margin-right: 0">
                        <i class="far fa-check-circle"
                           [class.c-red]="!condition.accepted"
                           [class.c-green]="condition.accepted">
                        </i>
                      </div>
                      <div class="list-two-line ">
				        <span class="list-primary-text typo-small"
                      style="font-size: 14px"
                      [innerText]="condition.condition">
				        </span>
                        <span class="list-secondary-text typo-small"
                              style="font-size: 12px"
                              [innerText]="condition.hint">
	              </span>
                      </div>
                      <div class="typo-right">
                        <exg-switch *ngIf="condition.showAccept"
                                    [(ngModel)]="condition.accepted">
                        </exg-switch>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </exg-popup>

          <div class="spawn-reverse">

            <button (click)="receiptReviewU_RevokeState(getRessource([10,20].includes(currentStatusEnmIdent) ? 'review.revokeAgain' : 'review.revoke'))"
                    *ngIf="rcptData.data && currentStatusEnmIdent &&
					                          (([3,10,20].includes(currentStatusEnmIdent) && securityHandler.powerUser())
					                           || ([3].includes(currentStatusEnmIdent) && !securityHandler.powerUser()))"
                    class="md-btn">
              {{getRessource([10,20].includes(currentStatusEnmIdent) ? 'review.revokeAgain' : 'review.revoke')}} <!--Bearbeiten-->
            </button>
            <button (click)="pickReview()"
                    [class.disabled]="!securityHandler.canPick()"
                    *ngIf="securityHandler.canPick()"
                    class="md-btn">
              {{getRessource('review.Pick')}} <!--Prüfung beginnen-->
            </button>
            <ng-container #SV *ngIf="[0,1,2,5].includes(currentStatusEnmIdent)">
              <button (click)="receiptReview(getRessource('review.proofIt'), true, undefined)"
                      class="md-btn" [disabled]="conditions.canChangeState()">
                {{getRessource('review.proofIt')}} <!--Fertigstellen/Zur Prüfung-->
              </button>
            </ng-container>
            <ng-container #IIS *ngIf="excSecurity.isFeatured(securityHandler.tokenPrefix + 'CHECK') && currentStatusEnmIdent === 4">
              <button (click)="receiptReview(getRessource('review.toSV'), true, undefined)"
                      class="md-btn">
                {{getRessource('review.toSV')}}<!--Zurück an SV-->
              </button>
              <button (click)="receiptReview(getRessource('review.cancel'), true, false)"
                      class="md-btn app-space-left"
                      [disabled]="conditions.canChangeState()">
                {{getRessource('review.cancel')}} <!--Stornieren-->
              </button>
              <button (click)="receiptReview(getRessource('review.accept'), true, true)"
                      class="md-btn"
                      [disabled]="conditions.canChangeState()">
                {{getRessource('review.accept')}} <!--freigeben-->
              </button>
            </ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="data.cvID || data.qverID || data.pdID">
          <button *ngIf="[3].includes(currentStatusEnmIdent) && !reportIsPicked" (click)="openConfirmationModal(2, 'Edit')" class="md-btn">
            {{getRessource('ReportStateActions.Edit')}}</button><!--Bearbeiten-->
          <button *ngIf="([3].includes(currentStatusEnmIdent) && reportIsPicked)" (click)="openConfirmationModal(5, 'Edit')" class="md-btn">
            {{getRessource('ReportStateActions.Edit')}}</button><!--Bearbeiten-->
          <button *ngIf="[2,5].includes(currentStatusEnmIdent)" (click)="openConfirmationModal( 3, 'Finish')" class="md-btn">
            {{getRessource('ReportStateActions.Finish')}}</button><!--Fertigstellen-->
          <button *ngIf="[3].includes(currentStatusEnmIdent)" (click)="openConfirmationModal( 4, 'BeginCheck')" class="md-btn">
            {{getRessource('ReportStateActions.BeginCheck')}}</button><!--Prüfung beginnen-->
          <button *ngIf="[4].includes(currentStatusEnmIdent)" (click)="openConfirmationModal(5, 'Correct')" class="md-btn">
            {{getRessource('ReportStateActions.Correct')}}</button><!--Korrigieren-->
          <button *ngIf="[4].includes(currentStatusEnmIdent)" (click)="openConfirmationModal(  10, 'MarkChecked')" class="md-btn">
            {{getRessource('ReportStateActions.MarkChecked')}}</button><!--Geprüft markieren-->
          <button *ngIf="[4].includes(currentStatusEnmIdent)" (click)="openConfirmationModal( 20, 'Decline')" class="md-btn">
            {{getRessource('ReportStateActions.Decline')}}</button><!--Ablehnen-->
          <button *ngIf="[20,10].includes(currentStatusEnmIdent)" (click)="openConfirmationModal(5, 'ReEdit')" class="md-btn">
            {{getRessource('ReportStateActions.ReEdit')}}</button><!--Wiederbearbeiten-->
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
